module.exports = __webpack_public_path__ + "media/src/application/media/img/fog_clouds_png_by_paradise234-d5czivb-c21899fa1f28fe57a2441a5481e4a135.png";